import React, { useState } from 'react';
import './CreateCuratorForm.css';

const CreateCuratorForm = ({ onSubmit, onCancel }) => {
    const [formData, setFormData] = useState({ username: '', email: '', password: '' });
    const [error, setError] = useState('');

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.username || !formData.email || !formData.password) {
            setError('All fields are required.');
            return;
        }
        if (!formData.email.endsWith('@eyantra.com')) {
            setError('Invalid email domain. Curators must use an @eyantra.com email address.');
            return;
        }
        setError('');
        onSubmit(formData);
    };

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <h2>Create New Curator</h2>

                {/* Scrollable container for the form inputs */}
                <div className="modal-body-scroll">
                    <form id="createCuratorForm" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Username</label>
                            <input
                                type="text"
                                name="username"
                                value={formData.username}
                                onChange={handleChange}
                                required
                                placeholder="Enter username"
                            />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder="employee@eyantra.com"
                            />
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                placeholder="Set initial password"
                            />
                        </div>
                    </form>
                </div>

                {/* Error and Actions fixed at the bottom */}
                {error && <p className="error-message">{error}</p>}

                <div className="form-actions">
                    <button type="button" onClick={onCancel} className="btn-cancel">
                        Cancel
                    </button>
                    <button type="submit" form="createCuratorForm" className="btn-submit">
                        Create Curator
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateCuratorForm;